/**
 * Returns the common SEO title suffix used across static pages.
 *
 * @returns The shared SEO title suffix string.
 */
export function getSeoTitleSuffix(): string {
	return ' - Sole 24ORE Business School';
}